import { images } from '../constants';
 
const services = [ 
    {
        id: 1,
        image: images.service1, 
        title: 'Car Maintenance',
        content: 'Comprehensive car maintenance to ensure your vehicle runs smoothly and efficiently.',
        paragraphs: [
            'Regular car maintenance is essential to keep your vehicle running smoothly and safely. From routine inspections to advanced diagnostics, our expert team ensures your car stays in optimal condition for peak performance and longevity.',
            'We offer a range of services, including oil changes, brake inspections, engine diagnostics, tire rotations, and fluid checks. Whether you drive a compact city car or a high-performance vehicle, we tailor our maintenance solutions to fit your specific needs.'
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: {
            intro: 'Discover why our car maintenance services are the best choice for keeping your vehicle road-ready.',
            list: [
                'Comprehensive vehicle inspections',
                'Routine maintenance for long-term reliability',
                'Engine and transmission servicing',
                'Expert care for all makes and models',
                'Enhances safety and fuel efficiency'
            ]
        },
        process: {
            intro: 'Our streamlined process ensures efficient and top-quality car maintenance services.',
            list: [
                'Initial vehicle assessment and diagnostic check',
                'Customized maintenance plan based on your car’s needs',
                'Regular servicing, including oil changes and tire checks',
                'Performance testing to ensure smooth operation',
                'Final inspection and recommendations for future upkeep'
            ]
        },
        faqs: [
            {
                id: 1,
                heading: 'How often should I service my car?',
                content: 'We recommend servicing your car every 5,000 to 7,500 miles, depending on your vehicle’s make and model. Regular maintenance helps prevent costly repairs in the future.'
            },
            {
                id: 2,
                heading: 'Do you use original manufacturer parts?',
                content: 'Yes, we use high-quality OEM and certified aftermarket parts to ensure the best performance and durability for your vehicle.'
            },
            {
                id: 3,
                heading: 'What types of vehicles do you service?',
                content: 'We service a wide range of vehicles, including sedans, SUVs, trucks, and performance cars. Contact us to confirm if we can service your specific model.'
            },
            {
                id: 4,
                heading: 'Can I schedule a maintenance appointment online?',
                content: 'Yes! You can book an appointment through our website or call us directly for a convenient time slot that fits your schedule.'
            }
        ]
    },
    {
        id: 2,
        image: images.service2, 
        title: 'Tire Services',
        content: 'Expert tire rotation, replacement, and balancing for optimal safety and performance.',
        paragraphs: [
            'Your vehicle’s tires play a crucial role in safety, handling, and fuel efficiency. Our expert tire services help extend tire life, improve performance, and keep you safe on the road.',
            'We offer a range of tire-related services, including tire installation, balancing, alignment, pressure checks, and puncture repairs. Whether you need new tires or maintenance for your existing ones, we’ve got you covered.'
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: {
            intro: 'Experience top-notch tire services to enhance road grip, fuel efficiency, and overall driving comfort.',
            list: [
                'Professional tire installation and replacement',
                'Wheel balancing and alignment for smooth driving',
                'Tire rotation to extend lifespan',
                'Puncture repairs for enhanced safety',
                'Tire pressure checks for optimal fuel efficiency'
            ]
        },
        process: {
            intro: 'Our streamlined process ensures efficient and high-quality tire services.',
            list: [
                'Comprehensive tire inspection and wear assessment',
                'Expert recommendations based on tread condition',
                'Tire installation, balancing, and alignment',
                'Final road test to ensure performance',
                'Regular maintenance tips for extended tire life'
            ]
        },
        faqs: [
            {
                id: 1,
                heading: 'How often should I rotate my tires?',
                content: 'We recommend rotating your tires every 5,000 to 7,500 miles to ensure even wear and extend their lifespan.'
            },
            {
                id: 2,
                heading: 'How do I know when I need new tires?',
                content: 'If your tread depth is below 2/32 of an inch, or if you notice cracks, bulges, or uneven wear, it’s time to replace your tires.'
            },
            {
                id: 3,
                heading: 'Do you offer tire balancing and alignment services?',
                content: 'Yes, we provide tire balancing and wheel alignment to improve handling, prevent uneven wear, and enhance fuel efficiency.'
            },
            {
                id: 4,
                heading: 'Can I bring my own tires for installation?',
                content: 'Yes, we offer installation services for customer-supplied tires. Contact us to schedule an appointment.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3, 
        title: 'Oil Change',
        content: 'Quick and reliable oil changes to keep your engine healthy and efficient.',
        paragraphs: [
            'Changing your oil regularly is one of the most important maintenance tasks for your vehicle. Fresh oil reduces engine wear, prevents overheating, and enhances overall performance.',
            'Our oil change service includes a complete drain and refill with high-quality oil, a new oil filter installation, and a multi-point inspection to ensure your engine stays in peak condition.'
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: {
            intro: 'Keep your engine healthy and efficient with our professional oil change services.',
            list: [
                'High-quality oil for superior engine protection',
                'Oil filter replacement to trap contaminants',
                'Improved fuel efficiency and engine performance',
                'Prevents sludge buildup and overheating',
                'Quick and efficient service with minimal wait time'
            ]
        },
        process: {
            intro: 'Our oil change process ensures optimal engine health and performance.',
            list: [
                'Inspection of current oil level and condition',
                'Draining old oil and removing the used filter',
                'Installing a new high-quality oil filter',
                'Refilling with manufacturer-recommended oil',
                'Final checks to ensure optimal engine operation'
            ]
        },
        faqs: [
            {
                id: 1,
                heading: 'How often should I change my oil?',
                content: 'Most vehicles require an oil change every 3,000 to 5,000 miles, depending on driving conditions and oil type.'
            },
            {
                id: 2,
                heading: 'What type of oil do you use?',
                content: 'We use high-quality synthetic, semi-synthetic, and conventional oils, depending on your vehicle’s needs and manufacturer recommendations.'
            },
            {
                id: 3,
                heading: 'Can an oil change improve fuel efficiency?',
                content: 'Yes, fresh oil reduces engine friction, leading to smoother operation and better fuel economy.'
            },
            {
                id: 4,
                heading: 'Do you check other fluids during an oil change?',
                content: 'Yes, we inspect and top off essential fluids, including coolant, brake fluid, and transmission fluid, if needed.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4, 
        title: 'Brake Services',
        content: 'Professional brake inspections and timely replacements for enhanced safety and performance.',
        paragraphs: [
            'Brakes are one of the most critical safety components of your vehicle. Regular brake maintenance helps prevent accidents and ensures your car stops effectively when needed.',
            'Our brake services include complete inspections, brake pad replacements, rotor resurfacing or replacement, brake fluid checks, and system diagnostics to guarantee optimal performance.'
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2
        ],
        features: {
            intro: 'Stay safe with reliable braking power through our comprehensive brake services.',
            list: [
                'Thorough brake system inspections',
                'Brake pad and rotor replacements',
                'Brake fluid flush and top-up',
                'Elimination of squeaking or grinding noises',
                'Enhanced stopping power and safety'
            ]
        },
        process: {
            intro: 'Our efficient brake service process ensures reliability and performance.',
            list: [
                'Inspection of brake pads, rotors, and fluid levels',
                'Diagnosis of any unusual noises or braking issues',
                'Brake pad and rotor replacement (if needed)',
                'Brake fluid flush and refill for smooth operation',
                'Final testing to ensure optimal braking performance'
            ]
        },
        faqs: [
            {
                id: 1,
                heading: 'How do I know if my brakes need servicing?',
                content: 'Signs include squeaking noises, reduced braking efficiency, a spongy brake pedal, or vibrations while braking.'
            },
            {
                id: 2,
                heading: 'How often should I replace my brake pads?',
                content: 'Brake pads typically last between 30,000 and 70,000 miles, depending on driving habits and conditions.'
            },
            {
                id: 3,
                heading: 'What happens if I delay brake service?',
                content: 'Delaying brake service can lead to increased stopping distances, unsafe driving conditions, and costly repairs.'
            },
            {
                id: 4,
                heading: 'Do you use high-quality brake parts?',
                content: 'Yes, we use top-grade brake pads and rotors from trusted manufacturers to ensure durability and safety.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5, 
        title: 'Battery Services',
        content: 'Battery testing, replacement, and maintenance for uninterrupted performance.',
        paragraphs: [
            'Your car battery is essential for starting your vehicle and powering electrical components. A weak or faulty battery can leave you stranded at the worst time.',
            'We provide comprehensive battery services, including diagnostics, charging system checks, battery replacements, and terminal cleaning to ensure long-lasting performance.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: {
            intro: 'Keep your vehicle powered with our expert battery services.',
            list: [
                'Comprehensive battery health diagnostics',
                'Battery charging and replacement services',
                'Terminal cleaning to prevent corrosion',
                'Testing of alternator and starter performance',
                'High-quality, long-lasting battery options'
            ]
        },
        process: {
            intro: 'Our streamlined battery service process ensures your car stays powered.',
            list: [
                'Battery health check and voltage testing',
                'Inspection of terminals and cables for corrosion',
                'Charging system and alternator performance test',
                'Battery replacement if necessary',
                'Final performance check for reliability'
            ]
        },
        faqs: [
            {
                id: 1,
                heading: 'How do I know if my battery needs replacement?',
                content: 'Signs include slow engine cranking, dim headlights, electrical issues, or a dashboard battery warning light.'
            },
            {
                id: 2,
                heading: 'How long does a car battery last?',
                content: 'Most car batteries last between 3 to 5 years, depending on driving conditions and maintenance.'
            },
            {
                id: 3,
                heading: 'Can you test my battery before replacing it?',
                content: 'Yes, we perform a full diagnostic test to determine whether your battery needs replacement or just maintenance.'
            },
            {
                id: 4,
                heading: 'Do you offer high-performance batteries?',
                content: 'Yes, we provide a range of top-quality batteries, including AGM and high-performance options, for long-lasting power.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6, 
        title: 'Car Inspection',
        content: 'Thorough car inspections to ensure your vehicle is roadworthy, safe, and performing optimally.',
        paragraphs: [
            'A comprehensive car inspection is essential to identify potential issues before they become costly repairs. Our experts conduct detailed evaluations to ensure your vehicle is roadworthy and performing at its best.',
            'We check all critical systems, including brakes, suspension, engine, tires, and emissions. Whether you need a routine inspection or a pre-purchase evaluation, we provide accurate assessments for your peace of mind.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: {
            intro: 'Ensure your car is safe and road-ready with our detailed inspection services.',
            list: [
                'Comprehensive multi-point inspection',
                'Brake, engine, and suspension assessment',
                'Tire tread and alignment checks',
                'Emission and fluid level evaluation',
                'Detailed inspection report with recommendations'
            ]
        },
        process: {
            intro: 'Our car inspection process is designed for accuracy and efficiency.',
            list: [
                'Initial vehicle walk-around and visual assessment',
                'Diagnostic scan for error codes and system faults',
                'Detailed inspection of brakes, tires, suspension, and engine',
                'Fluid level and emissions check',
                'Final report with findings and expert recommendations'
            ]
        },
        faqs: [
            {
                id: 1,
                heading: 'How often should I get my car inspected?',
                content: 'It’s recommended to have a full vehicle inspection at least once a year or before long road trips.'
            },
            {
                id: 2,
                heading: 'What’s included in a car inspection?',
                content: 'We inspect critical components such as brakes, tires, fluids, emissions, suspension, and overall vehicle performance.'
            },
            {
                id: 3,
                heading: 'Do you offer pre-purchase car inspections?',
                content: 'Yes, we provide detailed pre-purchase inspections to help you make an informed buying decision.'
            },
            {
                id: 4,
                heading: 'How long does a car inspection take?',
                content: 'A full inspection typically takes 60-90 minutes, depending on the vehicle’s condition and required checks.'
            }
        ]
    },
];

export default services;